import React, { useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SearchBanner from '../SearchBanner/SearchBanner';
import PasswordExpireBannerContainer from '../PasswordBanner/PasswordExpireBanner';
import SearchInsightsDocsBannerContainer from '../DocumentationBanner/SearchInsightDocsBannerContainer';
import AppConfig from '../../Config/AppConfig';
import { AppSelectors } from '../../Redux/modules/app/selectors';
import { UsersSelectors } from '../../Redux/modules/users/selectors';
import { AppActions } from '../../Redux/modules/app/actions';

const Banner = (props) => {
  const { user, passwordExpiration, userData, cookies, hasBanner, updateBannerState } = props;
  const searchBannerShowing = userData?.search_status?.is_in_trial;

  const shouldDisplayPasswordExpiryBanner =
    moment(passwordExpiration, 'YYYY/MM/DD hh:mm:ss').isBefore(moment(), 'day') &&
    user.shouldDisplayPasswordExpireBanner;

  const { si_documentation_banner_disabled_by_user: bannerDisabledByUser } = cookies;
  const siDocsBannerEnabled =
    AppConfig.SI_DOCS_BANNER_VISIBLE?.toLowerCase() === 'true' && bannerDisabledByUser?.toLowerCase() !== 'true';
  const shouldDhowDocumentationBanner =
    !searchBannerShowing && !shouldDisplayPasswordExpiryBanner && siDocsBannerEnabled;

  useEffect(() => {
    if (searchBannerShowing || shouldDisplayPasswordExpiryBanner || shouldDhowDocumentationBanner) {
      updateBannerState(true);
    }
  }, [searchBannerShowing, shouldDisplayPasswordExpiryBanner, shouldDhowDocumentationBanner]);

  return (
    <div>
      {hasBanner && (
        <>
          <SearchBanner isShowing={searchBannerShowing} />
          {shouldDisplayPasswordExpiryBanner && <PasswordExpireBannerContainer />}
          {shouldDhowDocumentationBanner && <SearchInsightsDocsBannerContainer />}
        </>
      )}
    </div>
  );
};

Banner.propTypes = {
  passwordExpiration: PropTypes.string,
  user: PropTypes.object,
  userData: PropTypes.object,
  cookies: PropTypes.object,
  hasBanner: PropTypes.bool,
  updateBannerState: PropTypes.func,
};
const mapStateToProps = (state) => {
  return {
    user: AppSelectors.userSelector(state),
    userData: UsersSelectors.usersDataSelector(state),
    passwordExpiration: AppSelectors.userSelector(state).passwordExpiration,
    hasBanner: AppSelectors.hasBannerSelector(state),
  };
};

const mapActionsToProps = {
  updateBannerState: AppActions.updateBannerState,
};
export default connect(mapStateToProps, mapActionsToProps)(Banner);
